import debounce from 'debounce-promise'
export const createFormValidationDebounce = (cb: Function, ms: number) => debounce(cb, ms)
